import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { getCurrentConversationId } from '../../../../reducers/aiAssistant.selectors';
import services from '../../../../services';
import {
	aiAssistantEditorContext,
	type PodcastDetailsData,
} from '../../../../state/AIAssistantEditorProvider';
import { downloadAudio } from '../utils';

// Podcast audio download with export tracking, shared by the desktop top bar, mobile
// header, and chat cards. Callers with their own podcast (chat cards) pass it; bare
// calls target the open detail view's podcast from the editor context.
const usePodcastAudioDownload = (
	podcast?: Pick<PodcastDetailsData, 'audioUrl' | 'title' | 'audioGenerationFailed'>
) => {
	const { podcastDetails } = useContext(aiAssistantEditorContext);
	const currentConversationId = useSelector(getCurrentConversationId);
	const target = podcast ?? podcastDetails;

	const isAudioDownloadDisabled = !target?.audioUrl || Boolean(target?.audioGenerationFailed);

	const handleAudioDownload = () => {
		if (!target?.audioUrl) return;
		// downloadAudio never rejects, so "download started" is the tracking point.
		void downloadAudio(target.audioUrl, target.title);
		if (!currentConversationId) return;
		services.track.ampliTrackTextEditorFileExportedEvent({
			conversationId: currentConversationId,
			exportType: 'download',
			exportFormat: 'wav',
			feature: ['podcast generation'],
		});
	};

	return { handleAudioDownload, isAudioDownloadDisabled };
};

export default usePodcastAudioDownload;
